import { render, staticRenderFns } from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=template&id=70147b68"
import script from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=style&index=0&id=70147b68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports